import { defineMessages } from 'react-intl'

const scope = 'app.components.GroupModal'

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage:
      '{mode, select, create {Create a new} edit {Edit} delete {Delete} other {}} Group{mode, select, view {:{name}} other {}}',
  },
  labels: {
    name: {
      id: `${scope}.labels.name`,
      defaultMessage: 'Group Name',
    },
    parentGroup: {
      id: `${scope}.labels.parentGroup`,
      defaultMessage: 'Parent Group',
    },
    zones: {
      id: `${scope}.labels.zones`,
      defaultMessage: 'Associated Zones',
    },
    actions: {
      id: `${scope}.labels.actions`,
      defaultMessage: 'Actions',
    },
  },
})
